import { AssignmentHeading } from './assignment-heading-preference.model';
import { StudentPreferenceColumn } from './student-column-preference.model';
import { AssignmentSortPreference } from './assignment-sort-preference.model';

export class GradebookPreferences {
    SyncPreferencesAcrossCourses: boolean;
    ShowUnitDropdown: boolean;
    ShowOnPortalRow: boolean;
    UseQuickAddWindow: boolean;
    DefaultShowOnPortal: boolean;
    AssignmentHeading: AssignmentHeading[] = [];
    SummaryCharacter: boolean;
    SummaryCharacterCount: number;
    SummaryCharacterSlide: boolean;
    SummaryCharacterSlideCount: number;
    ShowHorizontalHeading: boolean;
    AssignmentSort: AssignmentSortPreference[] = [];
    OriginalScore: boolean;
    Score: boolean;
    ScoreComment: boolean;
    EntireRowColumn: boolean;
    LetterGrades: boolean;
    WarnIfScoreEntered: boolean;
    PanelPopup: boolean;
    AutoSave: boolean;
    AutoSaveDuration: string;
    AvailableColumns: StudentPreferenceColumn[] = [];
    NonScrollingColumns: StudentPreferenceColumn[] = [];
    ScrollingColumns: StudentPreferenceColumn[] = [];
    ShowDroppedWithdrawn: boolean;
    ShowFuturStudents: boolean;
    StudentSortOrder: string;
    ShowProgressCycles: boolean;
    ShowTerms: boolean;
    ShowSemesters: boolean;
    ShowYearEnd: boolean;
    ShowAllTerms: boolean;
    PastTerms: string;
    PastTermEndedWithinNDays: number;
    FutureTerms: string;
    FutureTermStartingWithinNDays: number;
    ShowAssignmentsInStandards: boolean;
    DefaultForStandardsView: string;
    ShowHorizontalHeadingforStandardTab: boolean;
    ShowRowColumnnForSpecialMark: boolean;
    ReportCardGrades: number;
    ProjectFutureScores: boolean;
    IncludeCurrentCourseSection: boolean;
    FillBlankScores: string;
    FillBlankScoreValue: number;
    FillBlankScoreSpecialMarkId: string;
    FillBlankScoresAskEveryTime: boolean;
    CommentDelimiter: string;
    UseCommentCodes: boolean;
    ResetPreferences: boolean;
    ShowonlyStandardsCode: boolean;

    // Calculation Preferences
    FGradeCalculationType: string;
    SemesterFinalGradeCalculationPoints: string;
    SemesterFinalGradeCalculationCombo: string;
    NumericalGradeRoundTo: string;
    GPCWRound: string;
    GPCWRoundToValue: string;
    SemFinalRound: string;
    SemFinalRoundToValue: string;
    IsTotalPointCreated: boolean;
    SameCategoryWeights: boolean;
    PolicyOverrideCalculationType: boolean;
    PolicyOverrideAssignmentRound: boolean;
    PolicyOverrideGPCWRound: boolean;
    PolicyOverrideSemFinalRound: boolean;
}